module.exports = __webpack_public_path__ + "img/d-1-3.5739bf62.png";